import { RootState } from '@/store';
import { STORES_SLICE_NAME, StoresState } from './models';

export const storesSelector = (state: RootState): StoresState => state[STORES_SLICE_NAME];
